import { render, staticRenderFns } from "./product_channel.vue?vue&type=template&id=22d36f88&scoped=true"
import script from "./product_channel.vue?vue&type=script&lang=js"
export * from "./product_channel.vue?vue&type=script&lang=js"
import style0 from "./product_channel.vue?vue&type=style&index=0&id=22d36f88&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d36f88",
  null
  
)

export default component.exports